




































import { computed, defineComponent, onUnmounted, ref, toRef, toRefs, getCurrentInstance } from '@vue/composition-api';
import { QrcodeIcon, CloseIcon } from 'tdesign-icons-vue';
import i18n, { i18n_t } from '@/locales/i18n';
import inviteQrcodeHandler from '@/renderer/components/Qrcode/compositions/inviteQrcodeHandler';
import { copyText2Clipboard } from '@/renderer/scripts/utils/tools/index';
import tips from '@/renderer/scripts/utils/tips';
import { InviteUrlInfo } from '@/renderer/views/desktop/ManageConsole/UserManagement/innerUser/compositions/inviteMemberHandler';

export default defineComponent({
  name: 'InviteQrcode',
  props: {
    inviteUrlInfo: {
      type: Object as () => InviteUrlInfo,
      required: true,
    },
    formInvite: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  components: {
    QrcodeIcon,
    CloseIcon,
  },
  setup(props, context) {
    const vm = getCurrentInstance()?.proxy || context.root;
    const store = context.root.$store;
    const { qrcodeVisible, inviteUrl, methods: qrcodeMethods } = inviteQrcodeHandler(props.inviteUrlInfo);
    const codeStatus = computed(() => props.inviteUrlInfo.codeStatus);
    const inviteMemberContent = computed(() =>
      i18n_t('点击链接加入我的“{slot1}”{slot2}，一起开启文件协作管理新体验吧。', {
        slot1: props.inviteUrlInfo.groupName || '',
        slot2: store.getters.productName,
      }),
    );

    const copyContent = computed(() =>
      i18n_t('{slot1} 链接：{slot2}', {
        slot1: inviteMemberContent.value,
        slot2: inviteUrl.value,
      }),
    );

    const methods = {
      async onCopyText(val: string) {
        const canAddUser = await store.dispatch('checkUserCount');
        if (!canAddUser) return;
        copyText2Clipboard(val)
          .then(() => {
            tips.success(i18n_t('链接已复制，马上前往邀请成员'));
            context.emit('saved', 'copy');
          })
          .catch(() => {
            tips.error(i18n_t('复制失败'));
          });
      },
      drawQRCode() {
        qrcodeMethods.drawQRCode();
      },
      // 变更展示二维码
      showQrcode() {
        qrcodeMethods.showQrcode();
      },
      // 隐藏展示二维码
      hideQrcode() {
        qrcodeMethods.hideQrcode();
      },
      // 保存二维码到本地
      downloadQrcode() {
        qrcodeMethods.downloadQrcode();
        context.emit('saved', 'download');
      },
      // 重新生成链接
      regenerateInviteUrl() {
        context.emit('regenerateInviteUrl');
      },
    };
    onUnmounted(() => {
      qrcodeVisible.value = false;
    });
    return {
      copyText2Clipboard,
      inviteMemberContent,
      qrcodeVisible,
      inviteUrl,
      codeStatus,
      copyContent,
      ...methods,
    };
  },
});
